<template>
  <v-container fluid>
    <v-row dense>
      <v-col class="text-h3 gray--text text--lighten-1">
        Pacientes
      </v-col>
    </v-row>

    <v-row dense>
      <v-col cols="4">
        <v-text-field
          label="Busca por paciente"
          prepend-inner-icon="eva-search-outline"
          v-model="search"
          dense
          outlined
          background-color="white"
          clearable
          @keydown.enter="searchPatients"
        />
      </v-col>

      <v-col cols="4">
        <v-text-field
          label="Busca por prontuário"
          prepend-inner-icon="eva-search-outline"
          v-model="searchExternalId"
          dense
          outlined
          background-color="white"
          clearable
          @keydown.enter="searchPatients"
        />
      </v-col>

      <v-col cols="4">
        <v-btn color="theme--dark light-blue" @click="searchPatients">Buscar</v-btn>
      </v-col>
    </v-row>

    <v-row v-if="!lodash.isEmpty(patients)" align="start" cols="3" sm="6" md="6" lg="6">
      <v-col v-for="patient in patients" :key="patient.id">
        <PatientListItem :patient="patient" />
      </v-col>
    </v-row>

    <v-row justify="center" v-else>
      <v-col cols="6">
        <v-alert  color="orange" outlined text type="info">
          Nenhum paciente para ser exibido
        </v-alert>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import PatientListItem from "@/components/patient/list/item.vue";

export default {
  name: "Patients",
  components: {
    PatientListItem,
  },
  data() {
    return {
      search: "",
      searchExternalId: "",
      patients: [],
    };
  },
  methods: {
    searchPatients() {
      this.$apollo.query({
        query: require("@/graphql/patients/patients.gql"),
        variables: {
          name: this.search,
          externalId: this.searchExternalId
        },
      }).then(response => {

        const patientsOrdered = this.lodash.orderBy(response.data.patients, ["name", "asc"], ["warelineId", "asc"])

        this.patients = patientsOrdered;
      }).catch(error => {
        console.error("Erro ao buscar pacientes:", error);
      });
    },
  }
};
</script>

<style lang="scss" scoped></style>

